import { gql } from "@apollo/client";

export const GET_PRE_LIQUIDACION = gql`
query preLiquidacion($input: PreLiquidacionFiltersInput!){
    preLiquidacion(input: $input){
        success
        error
        valorEsperado{
            idLiquidacionProfesional
            idLiquidacionProfesionalDetalle
            idProfesional
            idEstadoLiquidacionProfesional
            profesional
            codigoSAPProfesional
            idEvaluacion
            idEvaluacionProfesional
            paciente
            fechaDesdeEvaluacion
            fechaHastaEvaluacion
            fechaDesdeProfesional
            fechaHastaProfesional
            diasServicio
            diasSuspendido
            totalDias
            cantVisitas
            programa
            planCuidado
            figuraProfesional
            liquidacionTotal
            liquidacionTotalMesAnterior
            observacionRechazo
            observacionDesestimar
            tieneConexion
            montoAjuste
            observacionAjuste
            tieneHonorarioFidelizado
            montoFidelizadoUnitario
        }
    }
}
`;